export const formattedPrice = (price, isUSD) => {
   return isUSD ? `$${price} USD` : `$${price} ARS`
}